import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
} from '@mui/material';

interface Order {
  id: string;
  accessionId: string;
  patientId: string;
  collectionDatetime: string;
  specimenClass: string;
  orderingPhysician: string;
  accessionLocationId: string;
  clinicalHistory: string;
  accessionedBy: string;
  accessionedById: string;
  grossingTechId: string;
  assignedPathologistId: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  amendedFromId?: number;
  amendedAt?: string;
  amendedBy?: string;
  version?: string;
  addendaId?: string;
  orderedBy?: number;
  orderDate?: string;
  createdBy?: string;
  sectionValues?: string;
}

interface VersionHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  versionHistory: Order[];
  loading: boolean;
  onVersionSelect: (version: Order) => void;
}

const VersionHistoryDialog: React.FC<VersionHistoryDialogProps> = ({
  open,
  onClose,
  versionHistory,
  loading,
  onVersionSelect,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Version History</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Version</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(versionHistory || []).map((version) => (
                <TableRow key={version.id}>
                  <TableCell>{version.version}</TableCell>
                  <TableCell>{version.status}</TableCell>
                  <TableCell>{new Date(version.createdAt).toLocaleString()}</TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      onClick={() => {
                        onVersionSelect(version);
                        onClose();
                      }}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionHistoryDialog; 